import {
    CREATE_PROPERTYGROUP_LOCALISATION_SUCCESS,
    DELETE_PROPERTYGROUP_SUCCESS,
    FETCH_PROPERTYGROUP,
    FETCH_PROPERTYGROUPS,
    FETCH_PROPERTYGROUPS_FAILURE,
    FETCH_PROPERTYGROUPS_SUCCESS,
    FETCH_PROPERTYGROUP_FAILURE,
    FETCH_PROPERTYGROUP_LOCALISATION,
    FETCH_PROPERTYGROUP_LOCALISATION_FAILURE,
    FETCH_PROPERTYGROUP_LOCALISATION_SUCCESS,
    FETCH_PROPERTYGROUP_SUCCESS,
    PROPERTYGROUPS_LIST_PAGE,
    PROPERTYGROUPS_LIST_SORT,
    SORT_ASC,
    UPDATE_PROPERTYGROUP_LOCALISATION_SUCCESS,
} from 'store/actions/types';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    ids: [],
    field: 'name',
    loading: false,
    localisation: {},
    offset: 0,
    order: SORT_ASC,
    page: 1,
    size: 24,
    total: 0,
};

export default function propertygroups(state = initialState, action) {
    switch (action.type) {
        case FETCH_PROPERTYGROUP:
        case FETCH_PROPERTYGROUPS:
        case FETCH_PROPERTYGROUP_LOCALISATION:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_PROPERTYGROUPS_FAILURE:
        case FETCH_PROPERTYGROUP_FAILURE:
        case FETCH_PROPERTYGROUP_LOCALISATION_FAILURE:
            return Object.assign({}, state, {
                loading: false,
            });

        case FETCH_PROPERTYGROUPS_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.payload.results, (value) => {
                return value.id;
            });

            const newIds = action.payload.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                ids: newIds,
                loading: false,
                offset: action.payload.offset,
                size: action.payload.size,
                total: action.payload.total,
            });

        case FETCH_PROPERTYGROUP_SUCCESS:
            const propertygroup = { [action.response.id]: action.response };

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, propertygroup),
                ids: [
                    ...state.ids,
                    ...action.response.id,
                ],
            });

        case FETCH_PROPERTYGROUP_LOCALISATION_SUCCESS:
            return Object.assign({}, state, {
                ids: [
                    ...state.ids,
                    ...action.payload.id,
                ],
                loading: false,
                localisation: Object.assign({}, state.localisation, {
                    [action.payload.id]: reducerHelper.formatLocalisations(action.response.results),
                }),
            });

        case CREATE_PROPERTYGROUP_LOCALISATION_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: Object.assign({}, action.response, action.payload.formValues.base),
                }),
                ids: [
                    ...state.ids,
                    ...action.response.id,
                ],
                loading: false,
                localisation: Object.assign({}, state.localisation, {
                    [action.response.id]: action.payload.formValues.localisation,
                }),
            });

        case UPDATE_PROPERTYGROUP_LOCALISATION_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.payload.id]: Object.assign({}, action.response, action.payload.formValues.base),
                }),
                loading: false,
                localisation: Object.assign({}, state.localisation, {
                    [action.payload.id]: action.payload.formValues.localisation,
                }),
            });

        case DELETE_PROPERTYGROUP_SUCCESS:
            const { id } = action.payload;

            const deletedData = reducerHelper.removeItemFromObject(state.data, id);
            const deletedStateIds = reducerHelper.removeItemFromArrayOfStrings(state.ids, id);

            return Object.assign({}, state, {
                data: deletedData,
                ids: deletedStateIds,
                loading: false,
                total: state.total - 1,
            });

        case PROPERTYGROUPS_LIST_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case PROPERTYGROUPS_LIST_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                order: action.payload.order,
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/propertygroupsReducer.js